<script>
export default {
    name: "Redirect",
    data() {
        return {
            url: '',
            decision_id: '',
            request_id_mark: 0,
            auto_redirect_decision: 0,
            waiting_redirect_decision: 0,
            mainColor: themeSettings.general.main_color.value,
        };
    },
    computed: {
        mainColor() {
            return {
                '--main-color': this.mainColor,
            };
        },
    },
    methods: {
        redirectHandler() {
            let url = import.meta.env.VITE_API_MARK_REDIRECTED;
                url += '?' + new URLSearchParams({
                    id: this.decision_id,
                    request_id_mark: this.request_id_mark,
                    auto_redirect_decision: this.auto_redirect_decision,
                    waiting_redirect_decision: this.waiting_redirect_decision

                });
            fetch(url).then(() => {
                console.log('redirected to' + this.url)
                window.location.href = this.url;
            }).catch((error) => {
                console.error(error);
                if (error.message === "Network Error") {
                    return
                }
                window.location.href = this.url;
            });
        },
    },
    mounted() {
        let el = document.querySelector('Redirect');
        this.url = el.dataset.url;
        this.decision_id = el.dataset.decisionId;
        if (el.dataset.requestIdMark) {
            this.request_id_mark = el.dataset.requestIdMark;
        }
        if (el.dataset.autoRedirectDecision) {
            this.auto_redirect_decision = 1
        }
        if (el.dataset.waitingRedirectDecision) {
            this.waiting_redirect_decision = 1
        }

        document.getElementById('link').href = '/redirect?id=' + this.decision_id;

        let seconds = 10;
        document.getElementById('timer').innerHTML = seconds;
        let interval = setInterval(() => {
            seconds--;
            document.getElementById('timer').innerHTML = seconds;
            if (seconds <= 0) {
                clearInterval(interval);
                document.getElementById('link').click();
            }
        }, 1000);
    }
}
</script>

<template>
    <div id="redirect">
        <div class="success-text text-center "  style="padding: 50px 20px 0 20px" >
            <h2><span class="highlited-word" :style="mainColor">Success</span></h2>
            <p> We have connected you to a lender. We are going to forward you
                to their webpage so you can
                continue. Please do not leave this page. Also the lender you connected with will be reaching out to you
                via phone,
                email or text.</p>
        </div>

        <div class="success-text text-center pb-5" style="padding: 5px; margin-top: 20px;">
            <p>If you would like to redirect now please click
                <button class="click-here-button" :style="mainColor" @click="redirectHandler">here</button>
            </p>
        </div>
        <div class="redirect-wrap">
            <div class="d-flex justify-content-center">
                <div class="spinner-grow" role="status">
                </div>
                <div class="spinner-grow" role="status">
                </div>
                <div class="spinner-grow" role="status">
                </div>
            </div>
            <div class="d-flex justify-content-center  pt-5">
                <p>You will be redirected to the&nbsp;<a :href="url" @click.prevent="redirectHandler" id="link">link</a>&nbsp;in&nbsp;<span
                    id="timer"></span>&nbsp;seconds</p>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
html {
    body {
        #app {
            #redirect {
                min-height: 60vh;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;

                .highlited-word {
                    font-weight: bold;
                    color: var(--main-color);
                }

                .success-text {
                    max-width: 500px;

                    .click-here-button {
                        font-weight: 600;
                        background: transparent;
                        border: none;
                        color: var(--main-color);
                    }
                }
            }

            .spinner-grow {
                margin: 0 5px;
            }

            .redirect-wrap a {
                padding-top: 20px;
                color: #0d6efd !important;
            }
        }
    }
}
</style>

